import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Carmen",
      business: "Dayfer Importaciones",
      quote: "Con el sistema de inventarios Pro revolucionó mi negocio. Ahora gestiono citas sin estrés y mis clientes están más satisfechos.",
      avatar: "👩"
    },
    {
      name: "Alfonso Rivera",
      business: "Academia basketballlab",
      quote: "Con el gestor de citas he podido ordenar la las reservas de las canchitas de baloncesto, esto me ahorra un montón de tiempo y esfuerzo.",
      avatar: "👨"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center text-[#03ADED] mb-8">Casos de éxito</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-8 rounded-xl border border-gray-200"
            >
              <div className="text-4xl mb-4">{testimonial.avatar}</div>
              <p className="text-lg italic mb-6 text-gray-700">"{testimonial.quote}"</p>
              <div>
                <p className="font-semibold text-gray-900">{testimonial.name}</p>
                <p className="text-gray-600">{testimonial.business}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;